import React, { useEffect, useState } from "react";
import {
  FluorescenceCaptureProperty,
  UltravioletCaptureProperty,
  VisibleCaptureProperty,
} from "../../../Model/CaptureProfile";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import { Binning } from "../../../Model/ImagerCapabilities";
import { BaseControl, FeatureLabel, UnitRadio } from "../ImagerFeatureControls";

type BinningControlProps = {
  binning: Binning;
  captureProperty: VisibleCaptureProperty | UltravioletCaptureProperty | FluorescenceCaptureProperty;
  onChange: (value: { binning: number }) => void;
  disabled: boolean;
};

export function BinningControl({ binning, captureProperty, onChange, disabled }: BinningControlProps) {
  const [biningValue, setBinningValue] = useState(captureProperty.binning);

  if (captureProperty.binning == null) {
    throw new Error("Capture profile binning is null");
  }

  useEffect(() => {
    setBinningValue(captureProperty.binning);
  }, [captureProperty.binning]);

  const onBiningChanged = (binning: number) => {
    setBinningValue(binning);
    onChange({ binning: binning });
  };

  var options = binning.binningDisplayValues.map((binningDisplayValue) => {
    const { binning } = binningDisplayValue;
    const display = binning + "x" + binning + " binning";

    return (
      <UnitRadio
        id={display}
        disabled={disabled}
        key={binning}
        label={display}
        onValueChanged={() => onBiningChanged(binning)}
        checked={biningValue === binning}
      />
    );
  });

  return (
    <BaseControl id={EOpticAndCameraFeature.Binning} key={EOpticAndCameraFeature.Binning} disabled={disabled}>
      <FeatureLabel disabled={disabled}>{"Binning:"}</FeatureLabel>
      <div
        style={{
          display: "flex",
          flexGrow: 1,
          marginLeft: 5,
          marginRight: 15,
          flexDirection: "row",
        }}
      >
        {options}
      </div>
    </BaseControl>
  );
}
